// $Id$ 
//ignorei18n_starts
var ZWAFInitialized = false
let payloadEncryption = {
	Request : {
		RequestInterceptor : {},
		RequestEncryption : {}
	},
	Response : {
		ResponseInterceptor : {},
		ResponseDecryption : {}
	},
	init : async function(zoid) {
			try {
				projectsZSEC.configuration.setCSRF({
					paramName: "zpcp",
					cookieName: "zpct"
				})
				const isZWAFInitialized = await projectsZSEC.Encryption.init({
					scope: projectsZSEC.Encryption.SCOPES.ORG,
					tag : zoid,
					preventCookieOverwrite : true,
					handshakeHeaders : {
						orgId : zoid
					},
					handshakeURL : payloadEncryption.Utils.getHandShakeURL(),
				});
				ZWAFInitialized = isZWAFInitialized ? true : false
			} catch (e) {
				console.warn("Handshake Problem :", e.message)
				ZWAFInitialized = false
			}
	},
	Utils : {
		getHandShakeURL : function(){
			 if((typeof IsWPloaded == "undefined" || !IsWPloaded) && (typeof crmpluslibcheck != "undefined" && crmpluslibcheck) && Utils.isCRMPlusPortal){
				 return "/portal/zwaf/encryption/handshake";
			 }
			 return "/zwaf/encryption/handshake"
		}
	}
}
payloadEncryption.Request.RequestInterceptor.Fetch = {
	interceptRequest : async function(url,options) {
		const isIgnoreUrl = payloadEncryption.Request.RequestInterceptor.Utils.isIgnoreUrl(url);
		if(!isIgnoreUrl){
			let payload = [];
			let quertString = payloadEncryption.Request.RequestInterceptor.Utils.retrieveQueryStringFromURL(url);
			let bodyParam = options.body ? options.body : "";
			payload.push(quertString)
			payload.push(bodyParam)
			const encryptedPayload = await payloadEncryption.Request.RequestEncryption.encrytRequestPayload(quertString,bodyParam)
			//console.log(encryptedPayload)
			const encryptedQueryStringAndPayload =  payloadEncryption.Request.RequestInterceptor.Fetch.getEncryptedQueryStringAndPayload(payload,encryptedPayload)
			let encryptedUrlString = payloadEncryption.Request.RequestInterceptor.Fetch.modifyRequestQueryString(url,encryptedQueryStringAndPayload)
			let encryptedBodyParams = payloadEncryption.Request.RequestInterceptor.Fetch.modifyRequestBodyParams(options,encryptedQueryStringAndPayload)
			payloadEncryption.Request.RequestInterceptor.Fetch.modifyHeader(options,encryptedQueryStringAndPayload)
			return {encryptedUrlString , encryptedBodyParams}
		}
	},
	getEncryptedQueryStringAndPayload : function(payload,encryptedPayload){
		let queryStringAndPayload = {};
		if(encryptedPayload?.data?.[0] && payload?.[0].length > 0){
			queryStringAndPayload.queryString = encryptedPayload.data[0]
		}
		if(encryptedPayload?.data?.[1] && payload?.[1].length > 0){
			queryStringAndPayload.bodyParam = encryptedPayload.data[1]
		}
		if(queryStringAndPayload && typeof queryStringAndPayload === 'object' && Object.keys(queryStringAndPayload).length != 0 && encryptedPayload?.key){
			queryStringAndPayload.key = encryptedPayload.key
		}
		return queryStringAndPayload;
	},
	modifyRequestQueryString : function(url,encryptedQueryStringAndPayload){
		if(url && encryptedQueryStringAndPayload?.queryString){			 
			return encryptedQueryStringAndPayload ? payloadEncryption.Request.RequestInterceptor.Utils.concatenateUrl(url,encryptedQueryStringAndPayload.queryString) || url : url 
		}	
	},
	modifyRequestBodyParams : function(options,encryptedQueryStringAndPayload){
		if(encryptedQueryStringAndPayload?.bodyParam){
			options.body = encryptedQueryStringAndPayload.bodyParam
			return encryptedQueryStringAndPayload.bodyParam
		}
	},
	modifyHeader : function(options,encryptedQueryStringAndPayload){
		if(encryptedQueryStringAndPayload?.key){
			options.headers[projectsZSEC.Encryption.constants.WAF_ENCRYPTION_KEY_HEADER] = encryptedQueryStringAndPayload.key 
			options.headers[projectsZSEC.Encryption.constants.WAF_ENCRYPTION_ID_HEADER] = projectsZSEC.Encryption.getWafEncryptionId()
		}
	}
}
payloadEncryption.Request.RequestInterceptor.Utils = {
	concatenateUrl : function(url,queryString){
		if(queryString){
			return url && url.split('?')[0] + '?' + queryString
		}
	},
	isIgnoreUrl : function(){
		return false;
	},
	retrieveQueryStringFromURL : function(url){
		// Return the query string, or an empty string if no query string is found
		return url && typeof url === 'string' && url.includes('?')? url.split('?')[1].split('#')[0] : ""; // Prevent Fragment Inclusion	
	}
}
payloadEncryption.Request.RequestEncryption = {
	encrytRequestPayload : async function(queryString,bodyParam){
		const keyAndIv = await payloadEncryption.Request.RequestEncryption.getReusableKey();
		//console.log("Reusable keyAndIv : ",keyAndIv);
		const encryptedData = await payloadEncryption.Request.RequestEncryption.encrypt(queryString,bodyParam,keyAndIv)
		return encryptedData
	},
	encrypt : async function(queryString,bodyParam,keyAndIv){
		const encryptedPayload = await projectsZSEC.Encryption.encrypt([queryString,bodyParam],keyAndIv)
		return encryptedPayload
	},
	getReusableKey : async function(){
		const reusableKey =  await projectsZSEC.Encryption.getReusableKey()
		return reusableKey
	}
}
payloadEncryption.Response.ResponseInterceptor = {
	interceptResponse : async function(response){
		const hasWafEncryptionKey = payloadEncryption.Response.ResponseInterceptor.isIgnoreUrl(response);
		if(hasWafEncryptionKey){
			const wafEncryptionKey = payloadEncryption.Response.ResponseInterceptor.getWafEncryptionKey(response);
			const responseText = await payloadEncryption.Response.ResponseDecryption.decryptResponsePayload(response,wafEncryptionKey);
			return responseText
		}else{
			const responseText = await response.text();
			return responseText
		}
	},
	isIgnoreUrl : function(response){
		const hasWafEncryptionKey = response.headers && response.headers.get('waf-encryption-key') ? true : false ;
		return hasWafEncryptionKey
	},
	getWafEncryptionKey : function(response){
		return response.headers && response.headers.get('waf-encryption-key') ? response.headers.get('waf-encryption-key') : undefined ;
	}
}
payloadEncryption.Response.ResponseDecryption = {
	decryptResponsePayload : async function(response,wafEncryptionKey){
		const encryptedResponse = await response.text(); 
		const decryptedResponse = await projectsZSEC.Encryption.decrypt(encryptedResponse,wafEncryptionKey);
		return decryptedResponse
	}
}

export { payloadEncryption, ZWAFInitialized };
//ignorei18n_ends